"use client";

import Image from "next/image";
import { useState } from "react";
import { TransformComponent, TransformWrapper, useControls } from "react-zoom-pan-pinch";
import styles from "./index.module.css";

interface ZoomableCarouselImageProps {
	src: string;
	alt: string;
}

const Controls = ({
	children,
	isZoomed,
}: {
	children: React.ReactNode;
	isZoomed: boolean;
}) => {
	const { zoomIn, zoomOut } = useControls();

	return (
		<div
			style={{ display: "contents", cursor: isZoomed ? "zoom-out" : "zoom-in" }}
			onClick={() => {
				if (isZoomed) {
					zoomOut(100);
				} else {
					zoomIn(100);
				}
			}}>
			{children}
		</div>
	);
};

export const ZoomableCarouselImage = ({ src, alt }: ZoomableCarouselImageProps) => {
	const [isZoomed, setIsZoomed] = useState(false);

	const handleZoomChange = (scale: number) => {
		const newZoomState = scale > 1;
		if (newZoomState !== isZoomed) {
			setIsZoomed(newZoomState);
		}
	};

	return (
		<TransformWrapper
			initialScale={1}
			minScale={1}
			maxScale={2}
			onTransformed={({ state }) => handleZoomChange(state.scale)}
			doubleClick={{
				mode: "reset",
			}}
			centerOnInit={true}
			wheel={{ step: 0.5 }}>
			<Controls isZoomed={isZoomed}>
				<TransformComponent wrapperStyle={{ width: "100%", height: "100%" }}>
					<div className={styles.modalImage}>
						<Image src={src} alt={alt} fill />
					</div>
				</TransformComponent>
			</Controls>
		</TransformWrapper>
	);
};
